import axios from 'axios';

const OrganisationAbnAcn = {
  search: async (endpoint, abnAcn) =>
    await axios
      .get(`${endpoint}/${abnAcn}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error.response;
      })
};

export default OrganisationAbnAcn;
